<template>
  <div class="footer-ad" v-if="!isClose && bannerList.length">
    <i v-if="bannerList.length" class="close" @click="closeAd"></i>
    <swiper v-if="bannerList.length" :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="banner in bannerList" :key="banner.id">
        <a class="link" :href="banner.link_url" target="_blank">
          <img class="image" :src="banner.content_url">
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        direction: 'vertical',
        autoplay: {
          delay: 5000
        },
        on: {
          // swiper初始化完成的回调
          init: () => {
            this.$nextTick(() => {
              this.mySwiper && this.mySwiper.el.addEventListener('mouseenter', this.mouseEnter)
              this.mySwiper && this.mySwiper.el.addEventListener('mouseleave', this.mouseLeave)
            })
          }
        },
        loop: true
      },
      bannerList: [],
      isClose: false
    }
  },
  computed: {
    mySwiper () {
      return this.$refs.mySwiper && this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    this.getAd()
  },
  methods: {
    getAd() {
      API.get(`/edu/zone/banners?type_id=106`).then(res => {
        if (res.status < 400) {
          this.bannerList = res.data.items
        }
      })
    },
    closeAd() {
      this.isClose = true
    },
    mouseEnter () {
      this.mySwiper && this.mySwiper.autoplay.stop()
    },
    mouseLeave () {
      this.mySwiper && this.mySwiper.autoplay.start()
    }
  },
  beforeDestroy () {
    this.mySwiper && this.mySwiper.el.removeEventListener('mouseenter', this.mouseEnter)
    this.mySwiper && this.mySwiper.el.removeEventListener('mouseleave', this.mouseLeave)
  }
}
</script>

<style lang="scss" scoped>
.footer-ad {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  width: 100%;
  height: 100px;
  .link {
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
  }
  .image {
    height: 100px;
    max-width: 2000px;
  }
  .close {
    width: 30px;
    height: 30px;
    display: block;
    background: url('https://public-static-edu.codemao.cn/redboat/icon_off@3x.png')
      no-repeat;
    background-position: 42% 50%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 30;
    cursor: pointer;
    position: absolute;
    right: 10%;
    top: 10px;
    border-radius: 100%;
    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
